import { FC } from "react";
import { Box, createStyles, Loader } from "@mantine/core";

const useStyles = createStyles((t) => ({
  wrapper: {
    flex: 1,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export const PageLoader: FC = () => {
  const { classes } = useStyles();
  return (
    <Box className={classes.wrapper}>
      <Loader />
    </Box>
  );
};
